export default __webpack_public_path__ + "static/media/ferrari.701170ec.jpg";